import { render, staticRenderFns } from "./disclaimer.vue?vue&type=template&id=259e9c0e&"
import script from "./disclaimer.vue?vue&type=script&lang=ts&"
export * from "./disclaimer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports